/* 🤖 this file was generated by svg-to-ts */
export const DfIconThumbsUp16: {
  name: 'thumbs-up-16';
  data: string;
} = {
  name: 'thumbs-up-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 13.557V6.446a2 2 0 0 1 .318-1.082L7.472.46A1 1 0 0 1 8.834.146l.57.349a1 1 0 0 1 .46 1.05l-.659 3.4a1 1 0 0 0 .866 1.184l4.444.517A1.73 1.73 0 0 1 16 8.36V9.54a2 2 0 0 1-.098.62l-1.452 4.46A2 2 0 0 1 12.548 16H7.339a2 2 0 0 1-.63-.101l-1.338-.444A2 2 0 0 1 4 13.557zM1 5h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" fill-rule="evenodd"/></svg>`
};
